import { gql } from "@apollo/client";
import { INVOICE_FIELDS } from "../queries/invoices";

export const CREATE_INVOICE = gql`
  ${INVOICE_FIELDS}
  mutation createInvoice(
    $agentId: String!
    $issueDate: DateTime
    $remark: String
    $lineItems: [InvoiceLineItemInput!]!
  ) {
    createInvoice(
      input: {
        agentId: $agentId
        issueDate: $issueDate
        remark: $remark
        lineItems: $lineItems
      }
    ) {
      ...invoiceFields
    }
  }
`;

export const RECORD_INVOICE_PAYMENT = gql`
  ${INVOICE_FIELDS}
  mutation recordInvoicePayment(
    $invoiceId: String!
    $amount: Float!
    $paymentDate: DateTime
    $remark: String
  ) {
    recordInvoicePayment(
      input: {
        invoiceId: $invoiceId
        amount: $amount
        paymentDate: $paymentDate
        remark: $remark
      }
    ) {
      ...invoiceFields
    }
  }
`;

export const CANCEL_INVOICE = gql`
  ${INVOICE_FIELDS}
  mutation cancelInvoice($id: String!) {
    cancelInvoice(id: $id) {
      ...invoiceFields
    }
  }
`;

export const UPSERT_GOV_REPORT_RATE = gql`
  mutation upsertGovReportRate($country: CountriesList!, $amount: Float!) {
    upsertGovReportRate(input: { country: $country, amount: $amount }) {
      _id
      country
      amount
    }
  }
`;
